import {
  DEFAULT_SERVICE_BUSINESS_INTL_CHARGE,
  DEFAULT_SERVICE_INTL_CHARGE,
  TRIP_TYPE_MULTI_CITY,
  TRIP_TYPE_ONE_WAY,
  USER_ROLE_EMPLOYEE,
  USER_ROLE_SUPERAGENT,
} from "../common/constants";

export const getServiceChargeInternational = (price, charges) => {
  if (charges?.length > 1 && charges[0].maxPrice) {
    const serviceChargeInternational = charges.find(
      (rule) => price >= rule.minPrice && price <= rule.maxPrice
    );

    return serviceChargeInternational?.charge || DEFAULT_SERVICE_INTL_CHARGE;
  } else {
    let serviceChargeInternational;

    if (price >= 0 && price <= 34999) {
      serviceChargeInternational = 11;
    } else if (price >= 35000 && price <= 49999) {
      serviceChargeInternational = 15;
    } else if (price >= 50000 && price <= 59999) {
      serviceChargeInternational = 18;
    } else if (price >= 60000 && price <= 69999) {
      serviceChargeInternational = 22;
    } else if (price >= 70000 && price <= 79999) {
      serviceChargeInternational = 25;
    } else if (price >= 80000 && price <= 89999) {
      serviceChargeInternational = 29;
    } else if (price >= 90000 && price <= 99999) {
      serviceChargeInternational = 33;
    } else if (price >= 100000 && price <= 199999) {
      serviceChargeInternational = 36;
    } else if (price >= 200000 && price <= 399999) {
      serviceChargeInternational = 45;
    } else if (price >= 400000 && price <= 599999) {
      serviceChargeInternational = 60;
    } else if (price >= 600000 && price <= 799999) {
      serviceChargeInternational = 100;
    } else if (price >= 800000 && price <= 999999) {
      serviceChargeInternational = 150;
    } else if (price >= 1000000) {
      serviceChargeInternational = 200;
    }
    return serviceChargeInternational;
  }
};

export const getBusinessServiceChargeInternational = (price, charge) => {
  console.log(charge, price);
  if (charge) {
    return charge;
  }

  return DEFAULT_SERVICE_BUSINESS_INTL_CHARGE;
  // if (charges?.length > 1) {
  //   const businessServiceChargeInternational = charges.find(
  //     (rule) => price >= rule.minPrice && price <= rule.maxPrice
  //   );

  //   return (
  //     businessServiceChargeInternational?.charge || DEFAULT_SERVICE_INTL_CHARGE
  //   );
  // } else {
  //   let businessServiceChargeInternational;

  //   if (price >= 0 && price <= 34999) {
  //     businessServiceChargeInternational = 14;
  //   } else if (price >= 35000 && price <= 49999) {
  //     businessServiceChargeInternational = 18;
  //   } else if (price >= 50000 && price <= 69999) {
  //     businessServiceChargeInternational = 21;
  //   } else if (price >= 70000 && price <= 89999) {
  //     businessServiceChargeInternational = 25;
  //   } else if (price >= 90000 && price <= 109999) {
  //     businessServiceChargeInternational = 28;
  //   } else if (price >= 110000 && price <= 129999) {
  //     businessServiceChargeInternational = 32;
  //   } else if (price >= 130000 && price <= 149999) {
  //     businessServiceChargeInternational = 35;
  //   } else if (price >= 150000 && price <= 199999) {
  //     businessServiceChargeInternational = 48;
  //   } else if (price >= 200000) {
  //     businessServiceChargeInternational = 57;
  //   }

  //   return businessServiceChargeInternational;
  // }
};

export const getNDCTotalPrice = (offer, user, count = 1, companySC) => {
  if (companySC?.length > 0) return 0;
  if (
    user?.role === USER_ROLE_SUPERAGENT ||
    user?.role === USER_ROLE_EMPLOYEE
  ) {
    return 0;
  }

  const NDCSC = [
    { carrier: "EK", oneWay: 0, round: 0 },
    { carrier: "KQ", oneWay: 800, round: 1500 },
    { carrier: "QR", oneWay: 300, round: 1100 },
    { carrier: "TK", oneWay: 1000, round: 2000 },
  ];

  const carrier = offer?.OfferID?.Owner;
  const { Associations } = offer?.PricedOffer;

  if (!Associations) return;

  let charge = NDCSC?.find((item) => item.carrier === carrier);

  if (Associations?.length > 1) charge = charge?.round;
  else charge = charge?.oneWay;

  return charge * count;
};

export const ServiceCharge = (
  airPricing,
  corporate,
  company,
  enterprise,
  discount,
  currencyStates,
  isLocalMulti,
  isLocal,
  query
) => {
  const {
    classType: cabinClass,
    tripType,
    adults,
    labors,
    children,
    passengerTypeState,
  } = Object.fromEntries(query.entries());

  let basePrice;
  let passengersPrice = {
    ADTPrice: 0,
    CNNPrice: 0,
  };

  if (airPricing instanceof Array) {
    passengersPrice = airPricing.map((item) => {
      const passengerTypes =
        item.PassengerType instanceof Array
          ? item.PassengerType
          : [item.PassengerType];

      passengerTypes.forEach((passenger) => {
        if (passenger._attributes.Code === "ADT") {
          passengersPrice.ADTPrice = item._attributes.TotalPrice;
        }
        if (passenger._attributes.Code === "CNN") {
          passengersPrice.CNNPrice = item._attributes.TotalPrice;
        }
      });

      return passengersPrice;
    });
  } else {
    passengersPrice = {
      ADTPrice: airPricing._attributes.TotalPrice,
      CNNPrice: 0,
    };
  }

  let merged = passengersPrice[0] || passengersPrice;

  let ADTTotal = +merged.ADTPrice.toString().slice(3);
  let CNNTotal = +merged.CNNPrice?.toString().slice(3) || 0;

  if (passengerTypeState === "Non-Document-Holder") {
    ADTTotal = (ADTTotal * corporate?.exchangeRate).toFixed(2);
    CNNTotal =
      CNNTotal > 0 ? (CNNTotal * corporate?.exchangeRate).toFixed(2) : 0;
  }

  if (discount?.companyIds?.includes(company?._id)) {
    basePrice = discount?.serviceCharge * (+adults + +children + +labors);
  } else {
    // Calculate basePrice
    if (+labors > 0 && company?.isLabor) {
      basePrice = company?.serviceChargeLabor * +labors;
    } else if (tripType === TRIP_TYPE_ONE_WAY && company?.isOneWay) {
      basePrice = company?.serviceChargeOneWay * (+adults + +children);
    } else {
      basePrice =
        getServiceChargeInternational(
          +ADTTotal,
          company?.serviceChargeInternational
        ) *
          (+adults || +labors) +
        (+CNNTotal > 0
          ? getServiceChargeInternational(
              +CNNTotal,
              company?.serviceChargeInternational
            ) * +children
          : 0);
    }
  }

  if (!company && !enterprise) return 0;
  if (tripType === TRIP_TYPE_MULTI_CITY ? isLocalMulti : isLocal)
    return (
      company?.serviceChargeLocal * (+adults + +children + +labors) ||
      enterprise?.serviceChargeLocal +
        enterprise?.company?.serviceChargeLocal *
          (+adults + +children + +labors)
    );
  else {
    // basePrice = basePrice?.toString().slice(3);

    // if (cabinClass === "Economy" || cabinClass === "Any") {
    return currencyStates === "USD"
      ? basePrice ||
          enterprise?.serviceChargeInternational +
            enterprise?.company?.serviceChargeInternational *
              (+adults + +children + +labors)
      : basePrice * corporate?.exchangeRate ||
          enterprise?.serviceChargeInternational +
            enterprise?.company?.serviceChargeInternational *
              (+adults + +children + +labors);
    // } else {
    //   return currencyStates === "USD"
    //     ? company?.serviceChargeInternationalBusiness *
    //         (+adults + +children + +labors) ||
    //         enterprise?.serviceChargeInternationalBusiness +
    //           enterprise?.company?.serviceChargeInternationalBusiness *
    //             (+adults + +children + +labors)
    //     : company?.serviceChargeInternationalBusiness *
    //         corporate?.exchangeRate *
    //         (+adults + +children + +labors) ||
    //         enterprise?.serviceChargeInternationalBusiness +
    //           enterprise?.company?.serviceChargeInternationalBusiness *
    //             corporate?.exchangeRate *
    //             (+adults + +children + +labors);
    // }
  }
};
